import { mdiBookmark, mdiBookmarkOutline } from '@mdi/js'
import Icon from '@mdi/react'

const AddBookmark = (props) => {
    const { size = 1, filled, ...other } = props

    return (
        <Icon
            data-testid="IconButton__AddBookmark"
            path={filled ? mdiBookmark : mdiBookmarkOutline}
            size={size}
            {...other}
        />
    )
}

export default AddBookmark
